import React, { type FC, useEffect, useState } from 'react';
import {
	type DropdownMenuProps,
	DropdownMenu as FriskDropdownMenu,
} from '@hdir/ui/dropdown-menu';


export const DropdownMenu: FC<DropdownMenuProps> = ({ disabled, ...otherProps }) => {
	const [hydrated, setHydrated] = useState(false);

	useEffect(() => {
		setHydrated(true);
	}, []);

	return (
		<FriskDropdownMenu {...otherProps} disabled={!hydrated || disabled} />
	);
};
